import { retryWhileDocumentHidden } from "utils/whenDocumentVisible";

var MAX_FILE_SIZE = 1024 * 1024 * 10;

var storeFile = function (file, payload) {
  if (file && file.size > MAX_FILE_SIZE) {
    var error = new Error("File exceeds 10MB");
    if (payload && payload.onError) payload.onError(error);
    return Promise.reject(error);
  }

  const client = filestack.init("Ab4UxJ7gSSG4hnZD7BeIHz");
  var upload_path = "/" + payload.environment + payload.path;
  if (payload.onUploadStarted) payload.onUploadStarted(file);

  return retryWhileDocumentHidden(function () {
    return client.upload(
      file,
      { retry: 5, timeout: 180000 },
      {
        filename: String(file.name || "reference.png")
          .replace(/ /g, "_")
          .replace(/\(/g, "-")
          .replace(/\)/g, "-")
          .replace(/\+/g, "-"),
        location: "s3",
        path: upload_path,
        access: "public",
      }
    );
  })
    .then(function (result) {
      const uploadsClient =
        typeof window !== "undefined" ? window.uploads : undefined;
      if (uploadsClient && typeof uploadsClient.transform === "function") {
        return Promise.resolve(
          uploadsClient.transform("callback", payload, result)
        ).then(function () {
          return result;
        });
      }
      return result;
    })
    .catch(function (error) {
      if (payload && payload.onError && !(error && error.uploadErrorNotified)) {
        if (error && typeof error === "object") {
          error.uploadErrorNotified = true;
        }
        payload.onError(error);
      }
      throw error;
    });
};

export default storeFile;
